import { BaserowClient } from "./baserow-client";

/**
 * Operations for managing Baserow trash and restoration.
 */
export class TrashOperations {
  constructor(private client: BaserowClient) {}
  
  // Trash methods will be implemented here
} 